export default "__VITE_ASSET__CdQUWKkP__"